import { css } from 'styled-components'

export const fontFaces = css`
  @font-face {
    font-family: 'Everett';
    src: url('/fonts/everett-light.woff2') format('woff2');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Everett';
    src: url('/fonts/everett-regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Everett';
    src: url('/fonts/everett-medium.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`